import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Visible error overlay — shows JS errors on screen for debugging
function showErrorOnScreen(message, source, lineno) {
  let overlay = document.getElementById('pf-error-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'pf-error-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#1a0000;color:#ff4444;padding:16px;font-family:monospace;font-size:14px;max-height:50vh;overflow:auto;border-bottom:3px solid #ff4444;white-space:pre-wrap;';
    document.body.appendChild(overlay);
  }
  const line = document.createElement('div');
  line.textContent = `[ERROR] ${message} (${source}:${lineno})`;
  line.style.cssText = 'margin:4px 0;padding:4px;background:rgba(255,0,0,0.1);border-radius:3px;';
  overlay.appendChild(line);
}

window.onerror = function(message, source, lineno, colno, error) {
  console.error('window.onerror:', { message, source, lineno, colno, error });
  showErrorOnScreen(String(message), source, lineno);
};
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  showErrorOnScreen('Promise: ' + (event.reason?.message || event.reason), '', 0);
});

const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
